import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import "./Auth.css";

function Signup() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/register`,
        formData
      );

      // Pass REAL data from backend to Context
      login(response.data.access_token, {
        name: response.data.user_name,
        email: response.data.user_email,
      });

      navigate("/analyze");
    } catch (err) {
      setError(err.response?.data?.detail || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-bg-animation" />

      <div className="auth-card">
        <div
          className="auth-logo"
          onClick={() => navigate("/")}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "2rem",
          }}
        >
          <img
            src="/logo.png"
            alt="Atlas Logo"
            style={{ height: "60px", width: "auto" }}
          />
        </div>

        <div className="auth-title">
          <h2>Join the Movement</h2>
          <p>Your freedom starts here.</p>
        </div>

        {error && <div className="error-banner">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="input-wrapper">
            <input
              type="text"
              required
              value={formData.full_name}
              onChange={(e) =>
                setFormData({ ...formData, full_name: e.target.value })
              }
              placeholder="Full Name"
            />
          </div>

          <div className="input-wrapper">
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              placeholder="Email Address"
            />
          </div>

          <div className="input-wrapper">
            <input
              type="password"
              required
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              placeholder="Password"
            />
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? " Creating..." : "Create Account"}
          </button>
        </form>

        <div className="auth-footer">
          Already a member?
          <Link to="/login" className="auth-link">
            Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Signup;